import Menus from "../Menus";

const HelpTopicQuestionSecurite = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Sécurité et accessibilité', link: '/topics/securite'},
    { label: 'Questions de sécurité', link: '/topics/securite/question-securite'},
  ]

  const multiMenus = [
    {title: null, filter: 'HelpTopicQuestionSecurite'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicQuestionSecurite